import { BRIDGE_VERSION } from "@ethisyscore/protocol";

export const EXTENSION_RUNTIME_PACKAGE = "@ethisyscore/extension-runtime";
export const BRIDGE = BRIDGE_VERSION;

// Re-export the canonical protocol constant under its original name so plugin
// authors can `import { BRIDGE_VERSION } from "@ethisyscore/extension-runtime"`
// without taking a direct dependency on `@ethisyscore/protocol`. The runtime
// is the public API surface for plugins; protocol is an internal dep.
export { BRIDGE_VERSION };

// MCP failure classification. Exported from the plugin entry point because the plugin is the side
// that branches on it, and from the host entry point because a host MCP client can attach
// `mcpErrorCode` to the errors it throws to control what the plugin sees.
export {
    McpToolError,
    isMcpToolError,
    isMcpErrorCode,
    isRetryableMcpErrorCode,
    mcpErrorCodeFromHttpStatus,
    classifyHostError,
    classifyHostResponse,
    MCP_ERROR_CODES,
    type McpErrorCode,
} from "./bridge/mcp-error";
